var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error"}},[_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center py-5 my-3"},[_c('h3',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }